var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0830078 0.130859V8.73205H12.1247V0.130859H0.0830078ZM7.016 4.66492C6.50423 5.15948 5.70345 5.15948 5.19469 4.66492L1.13966 0.74523H11.068L7.016 4.66492ZM3.97247 4.33008L0.685091 7.68455V1.15071L3.97247 4.33008ZM4.40898 4.75093L4.77926 5.10726C5.14954 5.46667 5.62819 5.64484 6.10384 5.64484C6.57949 5.64484 7.05814 5.46667 7.42842 5.10726L7.7987 4.75093L11.0981 8.11768H1.10956L4.40898 4.75093ZM8.23521 4.33008L11.5226 1.15071V7.68148L8.23521 4.33008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9f34418083ebea6954e8b151bb5a253b.svg";
export { ForwardRef as ReactComponent };